var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_18997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8562 27.3704C31.8193 30.2816 35.1356 32.1939 38.895 32.1939C44.9243 32.1939 49.8115 27.2757 49.8115 21.2098C49.8115 15.144 44.9243 10.2258 38.895 10.2258C32.8658 10.2258 27.9785 15.1433 27.9785 21.2098C27.9785 21.5509 27.994 21.8886 28.0242 22.2215",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8955 12.875V13.6322",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7539 13.9915L35.1305 14.6472",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7207 17.0427L32.3731 17.421",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6113 21.2098H31.3639",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7207 25.3775L32.3731 24.9993",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7539 28.4287L35.1305 27.7723",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8955 29.5453V28.7881",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0377 28.4287L42.6611 27.7723",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0697 25.3775L45.418 24.9993",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.18 21.2098H46.4268",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0697 17.0427L45.418 17.421",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0377 13.9915L42.6611 14.6472",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8954 16.5968V21.2098L37.1455 22.9706",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40527 24.3193C10.5176 21.5705 13.1997 19.6332 16.331 19.6332",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3818 19.6332C26.5098 19.6332 29.8563 23.0004 29.8563 27.1539V32.1939",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0459 32.1946H1.00098",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3311 19.6332L19.3561 22.0503L22.3818 19.6332",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3557 18.2304C23.1063 18.2304 26.1469 15.171 26.1469 11.3971C26.1469 7.62325 23.1063 4.5639 19.3557 4.5639C15.605 4.5639 12.5645 7.62325 12.5645 11.3971C12.5645 15.171 15.605 18.2304 19.3557 18.2304Z",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3555 22.0503V32.1946",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9541 28.4051V32.1946",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2774 32.1946L2.52344 24.3185H16.0063L17.7603 32.1946",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_18997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 37,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon2);
export default __webpack_public_path__ + "static/media/benefitIcon2.6b708753bec19b32f7e3fb51b50553f3.svg";
export { ForwardRef as ReactComponent };